var DOMEvents = /** @class */ (function () {
    function DOMEvents() {
    }
    DOMEvents.prototype.addEventListener = function (target, event, callback) {
        var _this = this;
        if (event.indexOf(',') > -1) {
            event.split(',').forEach(function (event) {
                _this.addEventListener(target, event, callback);
            });
        }
        else if (target) {
            if (target instanceof Array) {
                target.forEach(function (target) {
                    target === null || target === void 0 ? void 0 : target.addEventListener(event.trim(), callback);
                });
            }
            else {
                target === null || target === void 0 ? void 0 : target.addEventListener(event.trim(), callback);
            }
        }
    };
    DOMEvents.prototype.removeEventListener = function (target, event, callback) {
        var _this = this;
        if (event.indexOf(',') > -1) {
            event.split(',').forEach(function (event) {
                _this.removeEventListener(target, event, callback);
            });
        }
        else if (target) {
            if (target instanceof Array) {
                target.forEach(function (target) {
                    target === null || target === void 0 ? void 0 : target.removeEventListener(event.trim(), callback);
                });
            }
            else {
                target === null || target === void 0 ? void 0 : target.removeEventListener(event.trim(), callback);
            }
        }
    };
    return DOMEvents;
}());
export default DOMEvents;
//# sourceMappingURL=events.js.map